import {
  SubscriptionActiveFormData,
  SubscriptionActiveFormDataType,
  SubscriptionActiveFormFieldType,
} from "web/types/Subscription";

interface IValidationInfo {
  [key: string]: {
    type?: SubscriptionActiveFormFieldType;
    require?: boolean;
    requirementDependency?: string;
  };
}

// eslint-disable-next-line import/prefer-default-export
export const getValidationInfo = (
  activeFormData: SubscriptionActiveFormData[]
) => {
  const validationInfo: IValidationInfo = {};
  activeFormData.forEach((section) => {
    if (section.type === SubscriptionActiveFormDataType.FORM) {
      section.fields?.forEach((field) => {
        validationInfo[field.id] = {};
        if (field.type) {
          validationInfo[field.id].type = field.type;
        }
        if (field.require) {
          validationInfo[field.id].require = true;
        }
        if (field.requirementDependency) {
          validationInfo[field.id].requirementDependency =
            field.requirementDependency;
        }
      });
    } else if (
      section.type === SubscriptionActiveFormDataType.CONTENT &&
      section.useCheckbox
    ) {
      validationInfo[section.id] = {};
      if (section.checkboxRequired) {
        validationInfo[section.id].require = true;
      }
    }
  });
  return validationInfo;
};

export const typesWithValidations = [
  SubscriptionActiveFormFieldType.REQUIRE_PESEL,
  SubscriptionActiveFormFieldType.PESEL,
  SubscriptionActiveFormFieldType.EMAIL,
  SubscriptionActiveFormFieldType.PHONE,
  SubscriptionActiveFormFieldType.POSTCODE,
];
